<template>
  <transition-group
    v-bind:css="false"
    ref="list"
    name="list"
    tag="div"
    :class="[
      'grid-items',
      gridQueryClass,
      inResize ? 'in-resize' : '',
      limited ? 'limited' : ''
    ]"
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
    appear
  >
    <template v-if="gridType === 'catalog'">
      <router-link
        v-for="(item, index) in paginateditems"
        :key="item._id || item.Id || item.cat"
        :data-index="index"
        :class="['item', limited ? '' : 'pointer', itemsize + '-item']"
        :to="`/product/${item.cat}`">

        <!--:to="item.cat"  << This will open the popup --> 
        <!--:to="`product/${item.cat}`"  << This will go to the product page --> 

        <keep-alive>
          <catalog-item-preview
            type="result"
            :item="item"
            :size="itemsize"
            :key="index"
            :actions="[]"
            @collect-item="collectItem(item)"
          >
            <div class="label" slot="label" style="position:relative;">

              <!-- Add to list
              <div :class="['addToList',collections.activeCollectionItems.includes(item.productId) ? 'added' : '']" @click.prevent="addToCollection(item.productId)" 
                  :title="collections.activeCollectionItems.includes(item.productId) ? 'Product in list' : localize('Add to list')">
                  <i :class="['fal',collections.activeCollectionItems.includes(item.productId) ? 'fa-list-ul' : 'fa-list-ul']"></i>
              </div> -->

              <span class="item-mac" v-html="item.cat"></span>
              <span class="item-name font-rg text--s" v-html="(!!item.angle ? `${item.angle}° ` : '') + item.title" ></span>
              <span v-if="!!item.connection" class="item-details text--s" v-html="parseToString(item.connection)"></span>
              <span v-if="!!item.volume" class="item-details text--s" v-html="`${item.volume}cc`"></span>
              <span v-if="hasDimensions(item)" class="item-details text--s" v-html="parseDimensions(item, localize)"></span>
              <span v-if="!!item.concave_profile || !!item.procedure" class="item-details text--s" >
                <span v-if="!!item.concave_profile" v-text="'Concave Profile'"></span>
                <span v-if="!!item.concave_profile && !!item.procedure">|</span>
                <span v-if="!!item.procedure" v-html="parseToString(item.procedure)" ></span>
              </span>
              <span
                class="item-details text--s"
                v-if="!!item.membrane_size"
                v-html="item.membrane_size"
              ></span>
              <span
                class="item-details text--s"
                v-if="!!item.rotation"
                v-html="item.rotation"
              ></span>
            </div>
          </catalog-item-preview>
        </keep-alive>
      </router-link>
    </template>
    <template v-else-if="gridType === 'research'">
      <publication-list
        key="researchitems"
        type="result"
        :children="paginateditems"
        :size="itemsize"
        :has-search="false"
      ></publication-list>
    </template>
  </transition-group>
</template>

<script>
// import ResizeObserver from "resize-observer-polyfill";
// vuex
import { mapActions, mapState, mapGetters } from "vuex";
// components
import CatalogItemPreview from "@/components/catalog/CatalogItemPreview.vue";
// import ResearchItemPreview from "../components/ResearchItemPreview.vue";
// import PublicationList from "@/components/PublicationList.vue";
// plugins

import { parseDimensions, hasDimensions, parseToString } from "@/utils";

export default {
  props: {
    paginateditems: Array,
    perload: Number,
    withActions: {
      type: Boolean,
      default: true
    },
    // Used in related items inside (ItemView.vue)
    limited: {
      type: Boolean,
      default: false
    },
    itemsize: {
      type: String,
      default: "big"
    },
    gridType: String
  },
  data() {
    return {
      ro: null,
      elWidth: 0,
      elHeight: 0,
      inResize: false,
      resizetimer: -1,
      parseDimensions,
      hasDimensions,
      parseToString
    };
  },
  // watch: {
  //   paginateditems() {
  //     console.log("paginated items watch >> ", this.paginateditems);
  //   }
  // },

  components: {
    CatalogItemPreview
    // ResearchItemPreview
    // PublicationList
  },
  computed: {
    ...mapState(["collections", "auid"]),
    gridQueryClass() {
      let w = this.elWidth;
      return w === 0
        ? null
        : w > 1900
        ? "q-1900"
        : w > 1800
        ? "q-1800"
        : w > 1200
        ? "q-1200"
        : w > 950
        ? "q-950"
        : w > 650
        ? "q-650"
        : w > 470
        ? "q-470"
        : "q-min";
    },
    list() {
      let _items = this.allitems.slice(0, this.perpage); //_.take(this.filteredItems, this.itemsPerPage);
      return _items;
    }
  },
  methods: {
    ...mapActions(["setItemToCollect","updateStoreCollection","addItemToCollection","showCollectionsViewer"]),
    addToCollection(proID)
    {      
      var vm=this;
      if(!vm.collections.activeCollectionItems.includes(proID)){
          vm.addItemToCollection(proID);
      }
    },
    collectItem(item)
    {
      //alert("collect item:"+item.cat);
      //todo: display the collectionPicker 
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = this.limited ? "translateX(20%)" : "translateY(20%)";
    },
    enter: function(el, done) {
      var vm = this,
        lapse = this.limited ? 280 : 120,
        delay = (el.dataset.index % this.perload) * lapse,
        type = this.gridType;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: vm.limited
              ? ["translateX(20%)", "translateX(0)"]
              : ["translateY(20%)", "translateY(0)"],
            easing:
              type === "catalog"
                ? "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
                : "cubic-bezier(0.215, 0.61, 0.355, 1)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = this.limited
        ? "translateX(120%)"
        : "translateY(120%)";
      done();
    }
  }
};
</script>

<style scoped>
  .item-preview:hover .addToList
  {
    opacity: 1;
  }
  .added i
  {    
    color:#31a9f6 !important;
    background-color: transparent !important;
  }
</style>

<style lang="stylus" scoped>
.addToList
  opacity 1
  cursor pointer !important
  background-color none
  color #5e5e5e
  position absolute
  right -18px
  top 0px
  text-align center
  z-index 11
  opacity 0.4
  &:hover
    opacity 1
  i
    cursor pointer !important 
    line-height 30px
    font-size: 15px
    font-weight 500
    color #5e5e5e

.no-items
    font-size responsive 16px 32px
    color #fff
    self-center()

.grid-items
  opacity 1
  transition opacity 0.4s
  width 100%
  height 100%
  _flex(row, wrap, flex-start, flex-start)
  .item
    margin-bottom 30px
    flex 1
  /.el-size--large .item
  /.el-size--medium .item
    flex 0 0 23.875%
    margin 0 1.5% 4% 0
    &:nth-child(4n)
      margin 0
    +below(1100px)
      flex 0 0 32.3333%
      margin 0 1.5% 4% 0
      &:nth-child(4n)
        margin 0 1.5% 4% 0
      &:nth-child(3n)
        margin 0

  /.el-size--small .item
    flex 0 0 47%
    margin 0 6% 6% 0 !important
    &:nth-child(2n)
      margin 0 !important
  &.in-resize
      opacity 0
      transition none
  &.limited
    _flex(row, wrap, flex-start, space-between)
    padding-right 20px
    height 62vh
    overflow-x hidden
    overflow-y auto
    .item
      pointer-events none
      flex 0 0 calc(50% - 10px)
      margin 0 0 20px
</style>
